

<app-modal-header
  (close)="close()">
  <span slot="title">{{'admin.find-customer-modal.title' | translate }}</span>
</app-modal-header>


<div class="modal-body">

  <span class="p-input-icon-right w-full">
    <input type="text" pInputText [formControl]="queryFC" placeholder="{{'admin.find-customer-modal.search.placeholder' | translate }}" class="w-full">
    <ng-container *ngIf="fetching">
      <i class="pi pi-spin pi-spinner"></i>
    </ng-container>
    <ng-container *ngIf="!fetching">
      <i class="pi pi-search"></i>
    </ng-container>
  </span>

  <p-listbox
    *ngIf="searched"
    [options]="customers"
    [formControl]="selectedCustomerFC"
    emptyMessage="{{'admin.find-customer-modal.search.notfound' | translate }}"
    [listStyle]="{'max-height':'250px'}"
    class="mt-2 block">
    <ng-template let-customer pTemplate="item">
  
      {{ customer.orgUsers | userNameOrEmail:selectedOrg.getCurrentValue():true }}
  
    </ng-template>
  </p-listbox>
</div>